export default __webpack_public_path__ + "static/1inch-color-1-691d8ed4e08f3496addb537d3aae4f21.svg";